<template>
    <LoadingState :loading="loading" />
    <div v-if="!loading" class="w-full">
        <!-- start users -->
        <ul
            class="w-full h-auto justify-start items-start flex flex-row gap-1 @3xl:flex-col @3xl:gap-4"
        >
            <PointsCard
                v-for="user in pointsForProgram"
                :destinationProgram="{ ...user.points[0] }"
                :user="user"
                :usersCount="pointsForProgram.length"
                :key="user.id"
            />
        </ul>
        <!-- end users -->

        <!-- start brand logo -->
        <div
            class="self-stretch h-12 pt-6 flex-col justify-start items-start gap-2.5 flex"
        >
            <div class="w-[100px] lg:w-[80px] h-6 relative">
                <img
                    class="w-auto h-full left-0 top-0 absolute"
                    :src="programImage"
                />
            </div>
        </div>
        <!-- end brand logo -->
    </div>
</template>

<script>
import { ref, watchEffect } from 'vue';
import PointsCard from '@/components/hotels/property/points-card/points-card.vue';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';

export default {
    components: {
        LoadingState,
        PointsCard,
    },
    props: {
        programImage: String,
        pointsForProgram: Array,
        orientation: { type: String, default: 'horizontal', required: false },
    },
    setup(props) {
        const loading = ref(true);

        watchEffect(() => {
            if (props.programImage) {
                loading.value = false;
            }
        });

        return {
            loading,
        };
    },
};
</script>
